export default __webpack_public_path__ + "9fc25c2c10e4379074c526573cc8d762.png";